export default function StudentDashboard() {
  // بيانات افتراضية للإحصائيات
  const stats = [
    { 
      title: "الكورسات النشطة", 
      value: "8", 
      icon: "📚", 
      color: "#4CAF50", 
      trend: "+2 هذا الشهر",
      description: "كورسات قيد الدراسة"
    },
    { 
      title: "النسبة المئوية", 
      value: "65%", 
      icon: "📊", 
      color: "#2196F3", 
      trend: "+5% من الأسبوع الماضي",
      description: "متوسط إتمام الكورسات"
    },
    { 
      title: "ساعات الدراسة", 
      value: "42", 
      icon: "⏱️", 
      color: "#FF9800", 
      trend: "+8 ساعات هذا الأسبوع",
      description: "إجمالي ساعات الدراسة"
    },
    { 
      title: "الواجبات المكتملة", 
      value: "15", 
      icon: "✅", 
      color: "#9C27B0", 
      trend: "+3 هذا الأسبوع",
      description: "الواجبات المسلمة"
    }
  ];

  // الكورسات الأخيرة
  const recentCourses = [
    { 
      id: 1, 
      title: "React المتقدم", 
      progress: 85, 
      lastAccessed: "اليوم", 
      trainer: "أحمد محمد",
      color: "#4CAF50"
    },
    { 
      id: 2, 
      title: "Python للمبتدئين", 
      progress: 45, 
      lastAccessed: "أمس", 
      trainer: "سارة علي",
      color: "#2196F3"
    },
    { 
      id: 3, 
      title: "التصميم الجرافيكي", 
      progress: 30, 
      lastAccessed: "قبل يومين", 
      trainer: "محمد خالد",
      color: "#FF9800"
    },
    { 
      id: 4, 
      title: "اللغة الإنجليزية", 
      progress: 100, 
      lastAccessed: "الأسبوع الماضي", 
      trainer: "فاطمة أحمد",
      color: "#9C27B0"
    }
  ];

  // النشاطات الأخيرة
  const recentActivities = [
    { id: 1, text: "أكملت درس React Hooks", time: "منذ 2 ساعة", icon: "🎯" },
    { id: 2, text: "سلمت واجب Python", time: "منذ 5 ساعات", icon: "📤" },
    { id: 3, text: "شاركت في مناقشة المجموعة", time: "منذ يوم", icon: "💬" },
    { id: 4, text: "حصلت على شهادة HTML & CSS", time: "منذ 3 أيام", icon: "🏆" },
    { id: 5, text: "بدأت كورس التصميم الجرافيكي", time: "منذ أسبوع", icon: "🚀" }
  ];

  // المهام القادمة
  const upcomingTasks = [
    { id: 1, text: "واجب React رقم 3", dueDate: "غدًا", priority: "high", icon: "📝" },
    { id: 2, text: "امتحان Python النهائي", dueDate: "بعد 3 أيام", priority: "high", icon: "📚" },
    { id: 3, text: "مراجعة درس CSS Grid", dueDate: "الأسبوع القادم", priority: "medium", icon: "🎯" },
    { id: 4, text: "مشروع التخرج", dueDate: "شهر واحد", priority: "low", icon: "🏆" }
  ];

  return (
    <div style={styles.container}>
      {/* قسم الترحيب */}
      <div style={styles.welcomeSection}>
        <div style={styles.welcomeContent}>
          <h1 style={styles.welcomeTitle}>مرحبًا بك، أحمد! 👋</h1>
          <p style={styles.welcomeText}>استمر في التعلم والتطوير، أنت على الطريق الصحيح!</p>
        </div>
        <div style={styles.dateSection}>
          <span style={styles.dateText}>
            {new Date().toLocaleDateString('ar-SA', { 
              weekday: 'long', 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </span>
          <span style={styles.timeText}>
            {new Date().toLocaleTimeString('ar-SA', { 
              hour: '2-digit', 
              minute: '2-digit' 
            })}
          </span>
        </div>
      </div>

      {/* إحصائيات سريعة */}
      <div style={styles.statsGrid}>
        {stats.map((stat, index) => (
          <div key={index} style={styles.statCard}>
            <div style={styles.statHeader}>
              <div style={{...styles.statIcon, background: `${stat.color}20`, color: stat.color}}>
                {stat.icon}
              </div>
              <span style={styles.statTrend}>{stat.trend}</span>
            </div>
            <h3 style={styles.statValue}>{stat.value}</h3>
            <p style={styles.statTitle}>{stat.title}</p>
            <p style={styles.statDescription}>{stat.description}</p>
          </div>
        ))}
      </div>

      {/* المحتوى الرئيسي */}
      <div style={styles.mainContent}>
        {/* كورساتي الأخيرة */}
        <div style={styles.sectionCard}>
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>📚 كورساتي الأخيرة</h2>
            <a href="/student/my-courses" style={styles.viewAllLink}>عرض الكل →</a>
          </div>
          <div style={styles.coursesGrid}>
            {recentCourses.map((course) => (
              <div key={course.id} style={styles.courseCard}>
                <div style={styles.courseHeader}>
                  <div style={{...styles.courseIcon, background: `${course.color}20`, color: course.color}}>
                    📚
                  </div>
                  <div>
                    <h3 style={styles.courseTitle}>{course.title}</h3>
                    <p style={styles.courseTrainer}>المدرّب: {course.trainer}</p>
                  </div>
                </div>
                <div style={styles.progressContainer}>
                  <div style={styles.progressInfo}>
                    <span style={styles.progressLabel}>التقدم</span>
                    <span style={styles.progressValue}>{course.progress}%</span>
                  </div>
                  <div style={styles.progressBar}>
                    <div 
                      style={{
                        ...styles.progressFill,
                        width: `${course.progress}%`,
                        background: course.progress === 100 ? '#4CAF50' : course.color
                      }}
                    ></div>
                  </div>
                </div>
                <div style={styles.courseFooter}>
                  <span style={styles.lastAccessed}>آخر زيارة: {course.lastAccessed}</span>
                  <button 
                    style={{
                      ...styles.continueButton,
                      background: course.progress === 100 ? '#f5f5f5' : course.color,
                      color: course.progress === 100 ? '#333' : 'white'
                    }}
                  >
                    {course.progress === 100 ? 'مراجعة' : 'استكمال'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* النشاطات والمهام */}
        <div style={styles.sideContent}>
          {/* النشاطات الأخيرة */}
          <div style={styles.sectionCard}>
            <h2 style={styles.sectionTitle}>📝 النشاطات الأخيرة</h2>
            <div style={styles.activitiesList}>
              {recentActivities.map((activity) => (
                <div key={activity.id} style={styles.activityItem}>
                  <div style={styles.activityIcon}>{activity.icon}</div>
                  <div style={styles.activityContent}>
                    <p style={styles.activityText}>{activity.text}</p>
                    <span style={styles.activityTime}>{activity.time}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* المهام القادمة */}
          <div style={styles.sectionCard}>
            <h2 style={styles.sectionTitle}>⏰ المهام القادمة</h2>
            <div style={styles.tasksList}>
              {upcomingTasks.map((task) => (
                <div key={task.id} style={styles.taskItem}>
                  <div style={styles.taskIcon}>{task.icon}</div>
                  <div style={styles.taskContent}>
                    <p style={styles.taskText}>{task.text}</p>
                    <div style={styles.taskMeta}>
                      <span style={{
                        ...styles.taskPriority,
                        ...(task.priority === 'high' && styles.priorityHigh),
                        ...(task.priority === 'medium' && styles.priorityMedium),
                        ...(task.priority === 'low' && styles.priorityLow)
                      }}>
                        {task.priority === 'high' ? 'عالي' : 
                         task.priority === 'medium' ? 'متوسط' : 'منخفض'}
                      </span>
                      <span style={styles.taskDue}>موعد التسليم: {task.dueDate}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* نصائح سريعة */}
      <div style={styles.tipsCard}>
        <h2 style={styles.tipsTitle}>💡 نصائح للتعلم الفعال</h2>
        <div style={styles.tipsGrid}>
          <div style={styles.tipItem}>
            <span style={styles.tipIcon}>🎯</span>
            <p style={styles.tipText}>حدد هدفًا يوميًا للدراسة</p>
          </div>
          <div style={styles.tipItem}>
            <span style={styles.tipIcon}>⏱️</span>
            <p style={styles.tipText}>استخدم تقنية بومودورو (25 دقيقة دراسة، 5 دقائق راحة)</p>
          </div>
          <div style={styles.tipItem}>
            <span style={styles.tipIcon}>📝</span>
            <p style={styles.tipText}>دون ملاحظات أثناء مشاهدة الدروس</p>
          </div>
          <div style={styles.tipItem}>
            <span style={styles.tipIcon}>🔄</span>
            <p style={styles.tipText}>راجع الدروس السابقة بانتظام</p>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    direction: 'rtl',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    padding: '20px',
    background: '#f5f7fa',
    minHeight: '100vh',
  },
  welcomeSection: {
    background: 'linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)',
    color: 'white',
    padding: '30px',
    borderRadius: '15px',
    marginBottom: '30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 10px 30px rgba(76, 175, 80, 0.2)',
  },
  welcomeContent: {
    flex: 1,
  },
  welcomeTitle: {
    fontSize: '1.8rem',
    margin: '0 0 10px 0',
    fontWeight: '700',
  },
  welcomeText: {
    fontSize: '1rem',
    opacity: '0.9',
    margin: 0,
  },
  dateSection: {
    textAlign: 'left',
    background: 'rgba(255, 255, 255, 0.1)',
    padding: '15px 20px',
    borderRadius: '10px',
    backdropFilter: 'blur(10px)',
    minWidth: '200px',
  },
  dateText: {
    fontSize: '0.9rem',
    fontWeight: '500',
    display: 'block',
    marginBottom: '5px',
  },
  timeText: {
    fontSize: '1.2rem',
    fontWeight: '700',
    display: 'block',
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: '20px',
    marginBottom: '30px',
  },
  statCard: {
    background: 'white',
    padding: '25px',
    borderRadius: '12px',
    boxShadow: '0 5px 20px rgba(0, 0, 0, 0.08)',
    transition: 'transform 0.3s ease',
  },
  statHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '15px',
  },
  statIcon: {
    width: '50px',
    height: '50px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.8rem',
  },
  statTrend: {
    fontSize: '0.8rem',
    color: '#4CAF50',
    fontWeight: '600',
  },
  statValue: {
    margin: '0 0 5px 0',
    fontSize: '2.2rem',
    fontWeight: '700',
    color: '#333',
  },
  statTitle: {
    margin: '0 0 8px 0',
    fontSize: '1rem',
    color: '#333',
    fontWeight: '600',
  },
  statDescription: {
    margin: 0,
    fontSize: '0.85rem',
    color: '#666',
  },
  mainContent: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gap: '30px',
    marginBottom: '30px',
  },
  sideContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
  },
  sectionCard: {
    background: 'white',
    padding: '25px',
    borderRadius: '12px',
    boxShadow: '0 5px 20px rgba(0, 0, 0, 0.08)',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '25px',
  },
  sectionTitle: {
    fontSize: '1.3rem',
    margin: 0,
    color: '#333',
    fontWeight: '600',
  },
  viewAllLink: {
    color: '#4CAF50',
    textDecoration: 'none',
    fontSize: '0.9rem',
    fontWeight: '500',
    transition: 'all 0.2s ease',
  },
  coursesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '20px',
  },
  courseCard: {
    border: '1px solid #f0f0f0',
    borderRadius: '10px',
    padding: '20px',
    transition: 'all 0.3s ease',
  },
  courseHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    marginBottom: '20px',
  },
  courseIcon: {
    width: '50px',
    height: '50px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.5rem',
  },
  courseTitle: {
    margin: '0 0 5px 0',
    fontSize: '1.1rem',
    color: '#333',
    fontWeight: '600',
  },
  courseTrainer: {
    margin: 0,
    fontSize: '0.85rem',
    color: '#666',
  },
  progressContainer: {
    marginBottom: '20px',
  },
  progressInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
  },
  progressLabel: {
    fontSize: '0.85rem',
    color: '#666',
  },
  progressValue: {
    fontSize: '0.9rem',
    fontWeight: '600',
    color: '#333',
  },
  progressBar: {
    height: '8px',
    background: '#f0f0f0',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    borderRadius: '4px',
    transition: 'width 0.3s ease',
  },
  courseFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  lastAccessed: {
    fontSize: '0.8rem',
    color: '#999',
  },
  continueButton: {
    padding: '8px 15px',
    border: 'none',
    borderRadius: '6px',
    fontSize: '0.85rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  activitiesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  activityItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid #f0f0f0',
    transition: 'all 0.2s ease',
  },
  activityIcon: {
    fontSize: '1.2rem',
    minWidth: '35px',
    textAlign: 'center',
  },
  activityContent: {
    flex: 1,
  },
  activityText: {
    margin: '0 0 5px 0',
    fontSize: '0.9rem',
    color: '#333',
  },
  activityTime: {
    fontSize: '0.8rem',
    color: '#999',
  },
  tasksList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  taskItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid #f0f0f0',
    transition: 'all 0.2s ease',
  },
  taskIcon: {
    fontSize: '1.2rem',
    minWidth: '35px',
    textAlign: 'center',
    marginTop: '2px',
  },
  taskContent: {
    flex: 1,
  },
  taskText: {
    margin: '0 0 8px 0',
    fontSize: '0.9rem',
    color: '#333',
    fontWeight: '500',
  },
  taskMeta: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
  taskPriority: {
    fontSize: '0.75rem',
    padding: '2px 8px',
    borderRadius: '10px',
    fontWeight: '600',
  },
  priorityHigh: {
    background: '#ffebee',
    color: '#c62828',
  },
  priorityMedium: {
    background: '#fff3e0',
    color: '#ef6c00',
  },
  priorityLow: {
    background: '#f5f5f5',
    color: '#666',
  },
  taskDue: {
    fontSize: '0.75rem',
    color: '#666',
  },
  tipsCard: {
    background: 'white',
    padding: '25px',
    borderRadius: '12px',
    boxShadow: '0 5px 20px rgba(0, 0, 0, 0.08)',
  },
  tipsTitle: {
    fontSize: '1.3rem',
    margin: '0 0 20px 0',
    color: '#333',
    fontWeight: '600',
  },
  tipsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px',
  },
  tipItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    padding: '15px',
    background: '#f8f9fa',
    borderRadius: '10px',
    transition: 'all 0.2s ease',
  },
  tipIcon: {
    fontSize: '1.5rem',
    minWidth: '45px',
    textAlign: 'center',
  },
  tipText: {
    margin: 0,
    fontSize: '0.9rem',
    color: '#333',
    lineHeight: '1.5',
  },
};

// إضافة تأثيرات Hover
if (typeof window !== 'undefined') {
  setTimeout(() => {
    const style = document.createElement('style');
    style.textContent = `
      .stat-card-hover:hover {
        transform: translateY(-5px) !important;
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.12) !important;
      }
      
      .course-card-hover:hover {
        border-color: #4CAF50 !important;
        box-shadow: 0 8px 25px rgba(76, 175, 80, 0.1) !important;
        transform: translateY(-3px) !important;
      }
      
      .continue-btn-hover:hover {
        transform: translateY(-2px) !important;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1) !important;
      }
      
      .view-all-link-hover:hover {
        color: #2E7D32 !important;
        transform: translateX(-5px) !important;
      }
      
      .activity-item-hover:hover {
        border-color: #4CAF50 !important;
        background: #f8f9fa !important;
        transform: translateX(-5px) !important;
      }
      
      .task-item-hover:hover {
        border-color: #4CAF50 !important;
        background: #f8f9fa !important;
        transform: translateX(-5px) !important;
      }
      
      .tip-item-hover:hover {
        background: #e8f5e9 !important;
        transform: translateY(-3px) !important;
      }
      
      @media (max-width: 1024px) {
        .main-content-responsive {
          grid-template-columns: 1fr !important;
        }
      }
      
      @media (max-width: 768px) {
        .welcome-section-responsive {
          flex-direction: column !important;
          text-align: center !important;
          gap: 20px !important;
        }
        
        .date-section-responsive {
          text-align: center !important;
          width: 100% !important;
        }
        
        .stats-grid-responsive {
          grid-template-columns: repeat(2, 1fr) !important;
        }
        
        .courses-grid-responsive {
          grid-template-columns: 1fr !important;
        }
        
        .tips-grid-responsive {
          grid-template-columns: 1fr !important;
        }
      }
      
      @media (max-width: 480px) {
        .stats-grid-responsive {
          grid-template-columns: 1fr !important;
        }
        
        .course-footer-responsive {
          flex-direction: column !important;
          gap: 10px !important;
          align-items: flex-start !important;
        }
        
        .task-meta-responsive {
          flex-direction: column !important;
          align-items: flex-start !important;
          gap: 5px !important;
        }
      }
    `;
    document.head.appendChild(style);
    
    // إضافة classes للعناصر
    setTimeout(() => {
      const elements = [
        { selector: '[style*="statCard"]', className: 'stat-card-hover' },
        { selector: '[style*="courseCard"]', className: 'course-card-hover' },
        { selector: '[style*="continueButton"]', className: 'continue-btn-hover' },
        { selector: '[style*="viewAllLink"]', className: 'view-all-link-hover' },
        { selector: '[style*="activityItem"]', className: 'activity-item-hover' },
        { selector: '[style*="taskItem"]', className: 'task-item-hover' },
        { selector: '[style*="tipItem"]', className: 'tip-item-hover' },
      ];
      
      elements.forEach(({ selector, className }) => {
        document.querySelectorAll(selector).forEach(el => {
          el.className = (el.className || '') + ' ' + className;
        });
      });
      
      // Responsive classes
      if (window.innerWidth <= 1024) {
        const mainContent = document.querySelector('[style*="mainContent"]');
        if (mainContent) mainContent.className = (mainContent.className || '') + ' main-content-responsive';
      }
      
      if (window.innerWidth <= 768) {
        const elements = [
          { selector: '[style*="welcomeSection"]', className: 'welcome-section-responsive' },
          { selector: '[style*="dateSection"]', className: 'date-section-responsive' },
          { selector: '[style*="statsGrid"]', className: 'stats-grid-responsive' },
          { selector: '[style*="coursesGrid"]', className: 'courses-grid-responsive' },
          { selector: '[style*="tipsGrid"]', className: 'tips-grid-responsive' },
        ];
        
        elements.forEach(({ selector, className }) => {
          const element = document.querySelector(selector);
          if (element) element.className = (element.className || '') + ' ' + className;
        });
      }
      
      if (window.innerWidth <= 480) {
        const courseFooters = document.querySelectorAll('[style*="courseFooter"]');
        const taskMetas = document.querySelectorAll('[style*="taskMeta"]');
        
        courseFooters.forEach(el => {
          el.className = (el.className || '') + ' course-footer-responsive';
        });
        
        taskMetas.forEach(el => {
          el.className = (el.className || '') + ' task-meta-responsive';
        });
      }
    }, 200);
  }, 100);
}